import { BehaviorSubject } from 'rxjs'

import { FuelLayer } from '@/domain/protocols/Fuel'

import { MapADHPStateProps } from './MapADHPState'

type FuelADHPSnapshot = Pick<MapADHPStateProps, 'aerodromes' | 'helipads' | 'userWaypoints'>

export interface FuelStateProps {
  layer: FuelLayer
  previousADHPState: FuelADHPSnapshot | null
}

const INITIAL_STATE: FuelStateProps = {
  layer: null,
  previousADHPState: null
}

export const FuelState = new BehaviorSubject<FuelStateProps>(INITIAL_STATE)

export const FuelStateMutator = {
  mutate: (newState: FuelStateProps) => {
    FuelState.next(newState)
  },

  setLayer: (layer: FuelLayer) => {
    FuelState.next({
      ...FuelState.getValue(),
      layer
    })
  },

  setPreviousADHPState: (state: FuelADHPSnapshot | null) => {
    FuelState.next({
      ...FuelState.getValue(),
      previousADHPState: state
    })
  }
}
